import { Card, CircularProgress, Stack, Typography } from '@mui/material';

const DashboardHighlightCard = ({
  cardPrompt,
  isLoading,
  value,
}: {
  cardPrompt: string;
  isLoading: boolean;
  value: string | number | null | undefined;
}) => {
  return (
    <Card variant="outlined">
      <Stack
        direction="column"
        sx={{ justifyContent: 'center', alignItems: 'center', padding: 2 }}
      >
        <Typography sx={{ fontSize: 18 }}>{cardPrompt}</Typography>
        <Typography sx={{ fontSize: 34 }}>
          {isLoading ? (
            <CircularProgress size={30} sx={{ color: 'secondary.light' }} />
          ) : (
            value
          )}
        </Typography>
      </Stack>
    </Card>
  );
};

export default DashboardHighlightCard;
